/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';
import { CollaborationListItemFragment } from './ListingCollaborations.generated';

export type ListingRequestsForUserQueryVariables = Types.Exact<{
    input?: Types.Maybe<Types.ListRequestsInput>;
}>;

export type ListingRequestsForUserQuery = {
    __typename: 'Query';
    requestsForUser: {
        __typename: 'ListResponse';
        totalPages: number;
        totalResults: number;
        requests: Array<{ __typename: 'Request' } & RequestFragment>;
    };
};

export type RequestFragment = {
    __typename: 'Request';
    publicId: string;
    state: Types.RequestState;
    createdAt: Types.Maybe<any>;
    expertService: Types.Maybe<{
        __typename: 'ExpertService';
        title: string;
        printProduct: Types.Maybe<{ __typename: 'PrintProduct'; name: string; mpvId: string }>;
    }>;
    facts: Types.Maybe<{
        __typename: 'RequestFacts';
        briefId: Types.Maybe<string>;
        collaborateId: Types.Maybe<string>;
        jobId: Types.Maybe<string>;
        expertProductPrd: Types.Maybe<string>;
        printProductMpvid: Types.Maybe<string>;
        legacyRequestId: Types.Maybe<string>;
        designLiveAppointmentTime: Types.Maybe<any>;
        designLiveTimezone: Types.Maybe<string>;
        legacyProductName: Types.Maybe<string>;
        legacyRequestType: Types.Maybe<string>;
        isLegacyImport: Types.Maybe<boolean>;
        legacyDownloads: Types.Maybe<
            Array<{
                __typename: 'RequestLegacyDownload';
                downloadUrl: Types.Maybe<string>;
                previewUrl: Types.Maybe<string>;
            }>
        >;
    }>;
    collaborationListItem: Types.Maybe<
        { __typename: 'CollaborationListItem' } & CollaborationListItemFragment
    >;
    job: Types.Maybe<{
        __typename: 'Job';
        id: string;
        title: string;
        createdAt: any;
        type: Types.JobType;
    }>;
    brief: Types.Maybe<{
        __typename: 'Document';
        id: string;
        title: Types.Maybe<string>;
        createdAt: Types.Maybe<any>;
        description: Types.Maybe<string>;
        state: Types.BriefState;
    }>;
};

export const RequestFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Request' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Request' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expertService' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'printProduct' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'mpvId' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'facts' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'briefId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'collaborateId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'expertProductPrd' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'printProductMpvid' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'legacyRequestId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designLiveAppointmentTime' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designLiveTimezone' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'legacyProductName' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'legacyRequestType' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'legacyDownloads' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'downloadUrl' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'previewUrl' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'isLegacyImport' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'collaborationListItem' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'CollaborationListItem' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'job' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'brief' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CollaborationListItem' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'CollaborationListItem' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completion' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'at' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'careforceRequestAltId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appointment' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'zoomMeetingUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'durationMinutes' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'canBeRescheduled' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designerCalendarId' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'designerName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'rescheduleUrl' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'revisions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'isUnlimited' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slaHours' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expertRequestId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isLegacy' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isReviewEligible' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastDeliveringDesigner' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'canonicalId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'participantRole' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'freelancerId' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'viewerRole' } },
                ],
            },
        },
    ],
};
export const ListingRequestsForUserDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ListingRequestsForUser' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ListRequestsInput' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestsForUser' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'requests' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'Request' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'totalResults' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Request' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Request' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expertService' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'printProduct' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'mpvId' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'facts' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'briefId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'collaborateId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'expertProductPrd' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'printProductMpvid' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'legacyRequestId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designLiveAppointmentTime' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designLiveTimezone' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'legacyProductName' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'legacyRequestType' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'legacyDownloads' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'downloadUrl' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'previewUrl' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'isLegacyImport' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'collaborationListItem' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'CollaborationListItem' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'job' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'brief' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CollaborationListItem' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'CollaborationListItem' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completion' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'at' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'careforceRequestAltId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appointment' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'zoomMeetingUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'durationMinutes' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'canBeRescheduled' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designerCalendarId' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'designerName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'rescheduleUrl' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'revisions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'isUnlimited' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slaHours' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expertRequestId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isLegacy' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isReviewEligible' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastDeliveringDesigner' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'canonicalId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'participantRole' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'freelancerId' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'viewerRole' } },
                ],
            },
        },
    ],
};

/**
 * __useListingRequestsForUserQuery__
 *
 * To run a query within a React component, call `useListingRequestsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingRequestsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingRequestsForUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingRequestsForUserQuery(
    baseOptions?: Apollo.QueryHookOptions<
        ListingRequestsForUserQuery,
        ListingRequestsForUserQueryVariables
    >
) {
    return Apollo.useQuery<ListingRequestsForUserQuery, ListingRequestsForUserQueryVariables>(
        ListingRequestsForUserDocument,
        baseOptions
    );
}
export function useListingRequestsForUserLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ListingRequestsForUserQuery,
        ListingRequestsForUserQueryVariables
    >
) {
    return Apollo.useLazyQuery<ListingRequestsForUserQuery, ListingRequestsForUserQueryVariables>(
        ListingRequestsForUserDocument,
        baseOptions
    );
}
export type ListingRequestsForUserQueryHookResult = ReturnType<
    typeof useListingRequestsForUserQuery
>;
export type ListingRequestsForUserLazyQueryHookResult = ReturnType<
    typeof useListingRequestsForUserLazyQuery
>;
export type ListingRequestsForUserQueryResult = Apollo.QueryResult<
    ListingRequestsForUserQuery,
    ListingRequestsForUserQueryVariables
>;
